module.exports = __webpack_public_path__ + "img/lazada.e538159b.png";